import React from "react";

const NoAccess = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>🚫 Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default NoAccess;
